import { render } from "./Footer.vue?vue&type=template&id=6812c5c0"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=6812c5c0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__